@if (visible) {
<ion-button
  expand="block"
  [ngClass]="['btn-outline', customClass]"
  [class.has-top-padding]="topPadding"
  [disabled]="disabled"
  (click)="clicked.emit()"
>
  @if (loading) {
  <ion-spinner slot="start" name="crescent" class="mr-2 w-4 h-4" />
  } @else if (icon) {
  <ion-icon slot="start" [name]="icon" aria-hidden="true" />
  }
  {{ loading ? ("loading-button.loading" | translate) : (label | translate) }}
</ion-button>
}
